import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dialog__header flex flex-column" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "upload-wrapper flex relative text-center align-items-center justify-content-center w-full" }
const _hoisted_4 = {
  key: 1,
  class: "upload-wrapper__file-list flex w-full h-full list-none absolute left-0 align-items-center"
}
const _hoisted_5 = { class: "field w-full description-field required mt-4" }

import { computed, ref, toRefs } from 'vue';
import FileUpload from 'primevue/fileupload';
import FilePreview from './components/FilePreview.vue';
import Dialog from 'primevue/dialog';
import useFileList from '@/composables/useFileList';
import { EMIT } from '@/enum';
import { FileInterface } from '@/types';
import { useDocumentsStore, PersonStores } from '@/store';

interface PropsInterface {
  title: string;
  className?: string | null;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddDocumentModal',
  props: {
    title: {},
    className: {},
    loading: { type: Boolean }
  },
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const documentStore = useDocumentsStore();
const profileStore = PersonStores.useUserProfileStore();
const { title } = toRefs(props);
const { files, addFiles, removeFile } = useFileList();
const description = ref(undefined);
const modalVisible = ref(true);

const hasError = computed(() => !!documentStore.error);

/**
 * create the form data for proper POST
 * of blob documents
 */
const createForm = (file: FileInterface) => {
  const formData = new FormData();
  formData.append('document', file.file as Blob);
  formData.append('name', file.name);
  if (description.value) formData.append('description', description.value);

  return formData;
};

/**
 * emit the SAVE to the parent with the files to upload,
 * reset the array and hide the modal
 * note: this only handles ONE file upload
 */
const save = async () => {
  const file: FileInterface = [...files.value][0];
  const formData = createForm(file);
  await documentStore.uploadDocument(profileStore.id as number, formData);

  if (!hasError.value) {
    modalVisible.value = false;
    emit(EMIT.SAVE);
  } else {
    removeFile(file);
  }
};

/**
 * on dropping the file to the uploader add to file storage
 */
const onDrop = (e: Event) => addFiles(e.files);

/**
 * get the form items and make sure theyre completed
 * before enabling the save button
 * @returns boolean
 */
const formDisabled = computed<boolean>(
  () => description.value === undefined || description.value === '' || ![...files.value].length,
);

const cancel = () => {
  removeError();
  emit(EMIT.CANCEL);
  modalVisible.value = false;
};

const removeError = () => (documentStore.error = undefined);

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
    class: "dialog__container add-document__modal",
    modal: true,
    draggable: false,
    onHide: cancel
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", {
          class: "m-0",
          textContent: _toDisplayString(props.title)
        }, null, 8, _hoisted_2)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        type: "secondary",
        text: "Cancel",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        type: "primary",
        text: _unref(title),
        disabled: formDisabled.value,
        onClick: save
      }, null, 8, ["text", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (!_unref(files).length)
          ? (_openBlock(), _createBlock(_unref(FileUpload), {
              key: 0,
              "custom-upload": true,
              class: "upload relative",
              "choose-label": "Choose file",
              accept: ".pdf, .doc, .docx",
              "invalid-file-type-message": 'Sorry, this file type is not supported. Please select a supported file type: {1}',
              auto: true,
              mode: "advanced",
              "show-cancel-button": false,
              "show-upload-button": false,
              "max-file-size": 100000000,
              "invalid-file-size-message": "Error: This file exceeds the max file size allowed.",
              onUploader: onDrop
            }, {
              empty: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("p", { class: "uploader-text font-bold text-base mt-2" }, [
                  _createElementVNode("span", { class: "underline cursor-pointer" }, "Choose File"),
                  _createTextVNode(" or drag and drop here ")
                ], -1),
                _createElementVNode("p", { class: "acceptable-files-text" }, "Allowed types: .pdf, .doc, .docx", -1),
                _createElementVNode("p", { class: "acceptable-files-text" }, "Max File size: 100MB", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(files), (file) => {
                return (_openBlock(), _createBlock(FilePreview, {
                  key: file.id,
                  class: "w-full flex text-left align-items-center",
                  file: file,
                  tag: "li",
                  onRemove: _unref(removeFile)
                }, null, 8, ["file", "onRemove"]))
              }), 128))
            ]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { for: "description" }, "Description", -1)),
        _createVNode(_component_InputText, {
          id: "description",
          modelValue: description.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((description).value = $event)),
          required: "",
          class: "description-field__input w-full",
          name: "description"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})